// extracted by mini-css-extract-plugin
export default {"navy":"navy-0094","green":"green-6a8b","red":"red-5e69","gray":"gray-4355","darkgray":"darkgray-99be"};